import { lazyWithRetry } from './lazyWithRetry';

// The encounter page is the route every paying customer is redirected to, and it is code-split - so on
// a slow connection its chunk is not requested until the redirect fires, and React keeps the funnel's
// confirmation step on screen for the whole download. Measured on a throttled 3G profile that is
// several seconds of a finished-looking order that has not moved.
//
// The route lives here rather than beside the route table so checkout can warm it without importing
// AllRoutes, which would pull every layout and the whole route graph into the funnel bundle. Holding a
// dynamic import costs nothing: the chunk is fetched when the factory runs, not when this module loads.
export const EncounterPage = lazyWithRetry(() => import('../pages/Encounter'));

// called when a funnel reaches checkout, so the module is already resolved by the time payment
// succeeds. safe to call repeatedly - the bundler answers a second request from cache
export const preloadEncounterPage = () => {
	EncounterPage.preload();
};
